export const basePath = '/app/accommodations';

export const typeBasePath = `${basePath}/:type`;

export const types = ['hotel', 'resort', 'motel', 'hostel'];
